import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import './SuccessPage.scss'
import * as dayjs from 'dayjs'
import {mobileMode} from "@helpers/mobileHelper"
import {amplitudeEvent} from "@helpers/eventsHelper";
import { google } from "calendar-link";
import GoogleMaps from "@components/GoogleMaps/GoogleMaps";
import invoice from '@assets/images/invoice.png'
import calendar from '@assets/images/calendar.svg'
import vSign from '@assets/images/successPageV.svg'

const SuccessPage = (props) => {
    const [accountSettings, setAccountSettings] = useState({})
    const [noServicesMode, setNoServicesMode] = useState(false)
    const [contactToShow,setContactToShow] = useState({email:'', number:''});
    const [showContacts, setShowContacts] = useState(false);
    const event = {
        title: "",
        description: "",
        start: null,
        duration: [2, "hour"],
    };

    const mapContainerStyle = {
        position: 'relative',
        width: '100%',
        height: mobileMode() ? '155px' : '120px'
    }

    let eventDate = dayjs(new Date(props.form.date))
    let eventTime = dayjs().hour(0).minute(0).add(props.form.time, 'hours')

    const addToCalendar = () => {
        amplitudeEvent('bookingAddedToCalendar');

        let services = ""

        props.services.forEach((service) => {
            if(service.quantity > 0){
                services += `${service.item_name} - ${service.quantity} <br>`
            }
        })

        event.title = props.account.title
        const phone =  `Business Phone: ${props.account.telephone}`
        event.description = `${services} <br> Business Email: ${props.account.email} <br> ${props.account.telephone ? phone : ''}`
        event.start = dayjs(new Date(props.form.date)).hour(0).minute(0).add(props.form.time, 'hours')
        event.location = props.form.fullAddress.address
        if(props.form.fullAddress.city){
            event.location += ` ${props.form.fullAddress.city}`
        }
        if(props.form.fullAddress.state){
            event.location += ` ${props.form.fullAddress.state}`
        }
        if(props.form.fullAddress.zipcode){
            event.location += ` ${props.form.fullAddress.zipcode}`
        }

        window.open(google(event), '_blank').focus();
    }

    const calcServiceTotalTax = (service) => {
        const tax = ((props.account.paymentSettings?.tax / 100) * (service.booking_price * service.quantity)).toFixed(1)
        return service.taxable == "1" ? `$${tax}` : '-'
    }

    const renderServices = () => {
        return props.services.map(service => {
            if(service.quantity > 0){
                return <div key={service.p_id} className="service-row">
                    <div className="data jobType">{ props.jobTypes.find(jobType => jobType.id == props.selectedJobType)?.type_name }</div>
                    <div className="right-data">
                    <div className={`name ${!props.account.paymentSettings?.tax ? 'no-tax' : ''} `}>{service.item_name}</div>
                        <div className="data quantity">{service.quantity}</div>
                        {props.account.paymentSettings?.tax > 0 && <div className="tax-amount"> {calcServiceTotalTax(service)}</div>}
                        <div className={`data total ${!props.account.paymentSettings?.tax ? 'no-tax' : ''} `}>${service.booking_price * service.quantity}</div>
                    </div>
                </div>
            }else{
                return false
            }
        })
    }

    const renderTime = time => {
        if(time){
            const t1 = dayjs().hour(0).minute(0).add(time, 'hours')
            return t1.format(' h:mmA')
        }
    }

    useEffect(() => {
        setNoServicesMode(props.services.length === 0)
    }, [props.services])

    useEffect(() => {
        setAccountSettings(props.accountSettings)
        if(props.accountSettings?.use_business_contact === 1 ){
            setContactToShow({email: props.accountSettings.business_email, phone: props.accountSettings.business_phone})
            setShowContacts(true);
        } else {
            setShowContacts(false);
            setContactToShow({email: null, phone: null})
        }  
    }, []);
 
    return (
        <div className="success-page">
            <div className="summary">
                <div className={`titles ${!mobileMode() && noServicesMode ? 'no-thank-you' : ''}`}>
                    {(mobileMode() || !noServicesMode) &&<div className="title">Thank You for Choosing us!</div>}
                    <div className="booking-summary">{mobileMode() ? 'SUMMARY' : 'BOOKING SUMMARY'}</div>
                </div>
                {(accountSettings?.pending_approval_show === 1 && !noServicesMode) && <div className="pending-approval-msg">Your request is pending business approval</div>}
                <div className="summary-card">
                    <div className="summary-left">
                        {
                            !noServicesMode && <>
                                <div className="summary-titles">
                                    <div className={`title services ${!props.account.paymentSettings?.tax ? 'no-tax' : ''} `}>SERVICE</div>
                                    <div className={`right-title ${!props.account.paymentSettings?.tax ? 'no-tax' : ''} `}>
                                        <div className="title item">ITEM</div>
                                        <div className="title qty">QTY</div>
                                        {props.account.paymentSettings?.tax > 0 && <div className="title tax">TAX</div>}
                                        <div className="title total">TOTAL</div>
                                    </div>
                                </div>
                                <div className="header-border"></div>
                                <div className="services-wrapper">
                                    <div className="services">{renderServices()}</div>
                                    {!mobileMode() && <div className="sub-total-separator"></div>}
                                    <div className={`sub-total-row ${!props.account.paymentSettings?.tax ? 'no-tax' : ''} `}>
                                        <div className="sub-total">SUB TOTAL</div>
                                        <div className="sub-total-data">
                                            <div className="total-qty">{props.numOfServices}</div>
                                            {props.account.paymentSettings?.tax > 0 && <div className="total-tax">${props.totalTax}</div>}
                                            <div className="total-amount">${props.servicesTotalAmount}</div>
                                        </div>

                                    </div>
                                </div>
                                <div className="summary-total">
                                    <div className="items-in-total">TOTAL:</div>
                                    <div className="total-amount">${(props.servicesTotalAmount + props.totalTax).toFixed(2)}</div>
                                </div>
                            </>
                        }
                        {
                            noServicesMode && <div className="no-services-mode">
                                {
                                    !mobileMode() && <>
                                        <img alt="success" src={vSign}/>
                                        <div className="thank-you">Thank You for Choosing us!</div>
                                    </>
                                }
                                {accountSettings?.pending_approval_show === 1 && <div className="pending-approval">Your request is pending business approval</div>}
                            </div>
                        }

                    </div>
                    <div className="summary-right">
                        <div className="summary-titles date-time">
                            <div className="title date-time">DATE & TIME</div>
                        </div>
                        <div className="header-border"></div>
                        <div className="date-and-time">
                            <div className="date">
                                <div className="month">{eventDate.format("MMM")}</div>
                                <div className="day-in-month">{eventDate.format("DD")}</div>
                            </div>
                            <div className="vertical-separator"></div>
                            <div className="day-and-time">
                                <div className="day-name">{eventDate.format("dddd")}</div>
                                <div className="horizontal-separator"></div>
                                <div className="time">{eventTime.format("h:mmA")}</div>
                            </div>
                        </div>
                        {mobileMode() && <div className="header-border"></div>}
                        {
                            props.form.fullAddress?.address.length > 0 &&
                            <div className="location-wrapper">
                                <div className="location-title">LOCATION</div>
                                <div className="address-and-map">
                                    <div className="address">
                                        <div className="full-address-part">
                                            {props.form.fullAddress.address}
                                            {props.form.fullAddress.city && <span className="full-address-part">{props.form.fullAddress.city}, </span>}
                                            {props.form.fullAddress.state && <span className="full-address-part">{props.form.fullAddress.state}, </span>}
                                            {props.form.fullAddress.zip && <span className="full-address-part">{props.form.fullAddress.zip}</span>}
                                        </div>
                                    </div>
                                    <div className="map-wrapper">
                                        <GoogleMaps
                                            address={`${props.form.fullAddress.address} ${props.form.fullAddress.city} ${props.form.fullAddress.state} ${props.form.fullAddress.zip}`}
                                            containerStyle={mapContainerStyle}
                                        />
                                    </div>
                                </div>
                            </div>
                        }


                    </div>
                </div>
            </div>



            <div className="right-pane">
                {!mobileMode() && !noServicesMode && <img alt="invoice" src={invoice}/>}
                {!mobileMode() && noServicesMode && <img alt="calendar" src={calendar}/>}
                <div className="add-to-calendar" onClick={() => addToCalendar()}>Add to Calendar</div>
                {showContacts && <>
                <div className="in-any-question">If you have any question please contact us at:</div>
                <div className="contact-wrapper">
                    <a target="_blank" rel="noreferrer" href={`mailto:${contactToShow.email}`}>{contactToShow.email}</a>
                    <a href={`tel:${contactToShow.phone}`}>{contactToShow.phone}</a>
                </div>
                </>}
            </div>

        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        account: state.account,
        services: state.services,
        form: state.form,
        servicesTotalAmount: state.servicesTotals.totalAmount,
        numOfServices: state.servicesTotals.numOfServices,
        totalTax: state.servicesTotals.totalTax,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SuccessPage);